<template>
  <section>
    <div class="content-wrapper pb-4">
      <section class="content">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>